import { CompanyTariffNatureEntity } from "domain/entity/Company/CompanyTariffNatureEntity";
import { axiosGetData, axiosPostData, axiosPutData } from "../axios/AxiosBasicImpl";
import companyAxiosInstance from "../axios/companyAxiosInstance";
import { CompanyTariffNatureRepository } from "./CompanyTariffNatureRepo";

export const CompanyTariffNatureRepoImpl = (): CompanyTariffNatureRepository => {
    const url = '/v1/companyTariffNature';

    const searchCompanyTariffNature = async (companyId: number): Promise<CompanyTariffNatureEntity[]> => {
        const newUrl = url + '/';
        const result = axiosGetData(companyAxiosInstance, `${newUrl}` + companyId).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            let errorMessage = "Update Company Failure"
            if (err && err.response && err.response.data && typeof (err.response.data) === "string") {
                if (err.response.data.includes("already exist")) {

                }
            }
            throw new Error(errorMessage);
        });
        return result;
    }

    const addCompanyTariffNature = async (newData: CompanyTariffNatureEntity): Promise<Boolean> => {
        const newUrl = url + '/add';
        const result = axiosPostData(companyAxiosInstance, `${newUrl}`, newData).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            let errorMessage = "Update Company Failure"
            if (err && err.response && err.response.data && typeof (err.response.data) === "string") {
                if (err.response.data.includes("already exist")) {
                    errorMessage = `Duplicate record found, please check the key: Tariff Nature.`
                }
            }
            throw new Error(errorMessage);
        });
        return result;
    }

    const updateCompanyTariffNature = async (updatedData: CompanyTariffNatureEntity): Promise<Boolean> => {
        const newUrl = url + '/update';
        const result = axiosPutData(companyAxiosInstance, `${newUrl}`, updatedData).then(res => {
            const data = res.data;
            return data
        }).catch(error => {
            return null
        })
        return result
    }

    const saveCompanyTariffNature = async (saveDatas: CompanyTariffNatureEntity[]): Promise<Boolean> => {
        const newUrl = url + '/save';

        return await axiosPostData(companyAxiosInstance, `${newUrl}`, saveDatas).then(res => {
            if (res.msg === "OK") {
                return res.data;
            } else {
                let errorMessage = "Failed to save company tariff nature."
                if (res.data && typeof (res.data) === "string") {
                    errorMessage = res.data;
                }
                return "Error:" + errorMessage;
            }
        }).catch(err => {
            return "Error:" + err.Message;
        });
    }

    const deleteCompanyTariffNature = async (deleteData: CompanyTariffNatureEntity): Promise<Boolean> => {
        const newUrl = url + '/delete';
        const result = axiosPutData(companyAxiosInstance, `${newUrl}`, deleteData).then(res => {
            const data = res.data;
            return data
        }).catch(error => {
            return null
        })
        return result
    }

    return {
        searchCompanyTariffNature: searchCompanyTariffNature,
        addCompanyTariffNature: addCompanyTariffNature,
        updateCompanyTariffNature: updateCompanyTariffNature,
        deleteCompanyTariffNature: deleteCompanyTariffNature,
        saveCompanyTariffNature: saveCompanyTariffNature
    }
}